import { useMemo } from "react";
import type { LegalEntityHierarchy } from "@/services/profileService";
import { findEntityById } from "@/modules/settings/entityHelpers";

/** Legal entities visible for the current settings scope (all, or the selected LE subtree). */
export function useDisplayLegalEntities(
  legalEntities: LegalEntityHierarchy[] | undefined,
  legalEntityId: string | null | undefined,
): LegalEntityHierarchy[] {
  return useMemo(() => {
    const entities = legalEntities ?? [];
    if (!entities.length) return [];
    if (!legalEntityId) return entities;
    const selected = findEntityById(entities, legalEntityId);
    return selected ? [selected] : entities;
  }, [legalEntities, legalEntityId]);
}
